export default __webpack_public_path__ + "static/media/Shadow's Gloves of the Hidden Palace.fb1f8dce.jpg";